import { render, staticRenderFns } from "./ChangePasswordScreen.vue?vue&type=template&id=7cb50bba&scoped=true&"
import script from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordScreen.vue?vue&type=style&index=0&id=7cb50bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb50bba",
  null
  
)

component.options.__file = "ChangePasswordScreen.vue"
export default component.exports